export const validateEmail = (email: string) => {
  return (
    email &&
    String(email)
      .toLowerCase()
      .match(/^\S+@\S+\.\S+$/)
  );
};
